export const tr = {
    noData: 'Veri yok'
};
